import Layout from '@layout/Index'

export const todo = [
  {
    path: '/todo',
    component: Layout,
    children: [
      {
        path: 'project/table',
        component: () => import(/* webpackChunkName: "todo-project-table" */ '../customer-project/pages/ProjectTable.vue'),
        name: '项目审核',
        meta: {
          title: '项目审核',
          type: 'todo-project-table',
        },
      },
      {
        path: 'project/my-approval',
        component: () => import(/* webpackChunkName: "todo-project-my-approval" */ '../customer-project/pages/ProjectTable.vue'),
        name: '待审批项目',
        meta: {
          title: '待审批项目',
          type: 'todo-project-my-approval',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/todo/todo.route.js